export default __webpack_public_path__ + "static/media/menu_alta_modulo.cad561f8.svg";